import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataObjectIndicatorSchema } from '../schema/DataObjectIndicatorSchema';
import { DataObjectUrl } from './DataObjectUrl';

export interface DataObjectVersionIndicatorRequestParams {
  dataObjectVersionId: number;
  indicatorCode: string;
  key: string;
}

const getDataObjectVersionIndicator = (
  params: DataObjectVersionIndicatorRequestParams,
) =>
  apiClient
    .get(expand(DataObjectUrl.DATA_OBJECT_VERSION_INDICATOR, params))
    .then((response) => DataObjectIndicatorSchema.parse(response.data));

export const useDataObjectVersionIndicatorQuery = createApiQueryHook(
  ['data-object-version-indicator'],
  getDataObjectVersionIndicator,
);
